export const SUPPORTED_LANGUAGES = {
  en: {
    flagIcon: "gb-flag",
    language: "en",
    title: "English",
  },
  fr: {
    flagIcon: "fr-flag",
    language: "fr",
    title: "Français",
  },
  it: {
    flagIcon: "it-flag",
    language: "it",
    title: "Italiano",
  },
  nl: {
    flagIcon: "nl-flag",
    language: "nl",
    title: "Nederlands",
  },
  de: {
    flagIcon: "de-flag",
    language: "de",
    title: "Deutsch",
  },
};

export const MAP_TILE_URL =
  "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";

export const DEFAULT_MAP_CENTER = { lat: 50.701042, long: 3.153076 };
export const DEFAULT_MAP_ZOOM = 15;
